"use client";

// Fehlerzustand fuer den ganzen Bereich Spenden: ein Satz, ein Knopf.
// Die technische Meldung bleibt auf dem Server (im Produktionsbau
// ersetzt Next sie ohnehin durch die Kennung).

import { useEffect } from "react";
import Link from "next/link";
import { AlertTriangle } from "lucide-react";
import { Button, buttonVariants, EmptyState } from "@/components/ui";

export default function SpendenFehler({ error, retry }: { error: unknown; retry: () => void }) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  const kennung = typeof error === "object" && error && "digest" in error ? String((error as { digest?: unknown }).digest ?? "") : "";

  return (
    <div className="mx-auto max-w-xl py-10">
      <EmptyState
        icon={AlertTriangle}
        title="Die Spenden ließen sich nicht laden"
        description={kennung ? `Fehlerkennung ${kennung} — bitte bei der Ansichtssache melden, wenn es bleibt.` : "Bitte noch einmal versuchen."}
        action={
          <div className="flex flex-wrap justify-center gap-2">
            <Button onClick={() => retry()}>Noch einmal</Button>
            <Link href="/spenden" className={buttonVariants({ variant: "outline" })}>
              Zur Übersicht
            </Link>
          </div>
        }
      />
    </div>
  );
}
